var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { cloneDeep } from "lodash";
export var transformObjectsToTreeObjects = function (objects) {
    var allNodes = objects
        .map(transformObjectToTreeObject)
        .sort(function (a, b) { return b.idObjectType - a.idObjectType; });
    var _loop_1 = function (node) {
        var children = cloneDeep(allNodes
            .filter(function (item) { return item.idParent === node.id; })
            .map(function (item) { return (__assign(__assign({}, item), { parent: node })); }));
        node.children = children;
        if (!node.parent) {
            var parent_1 = allNodes.find(function (item) { return item.id === node.idParent; });
            node.parent = parent_1;
        }
    };
    for (var _i = 0, allNodes_1 = allNodes; _i < allNodes_1.length; _i++) {
        var node = allNodes_1[_i];
        _loop_1(node);
    }
    return allNodes;
};
var transformObjectToTreeObject = function (obj) { return (__assign(__assign({}, obj), { children: [] })); };
